export default "__VITE_PUBLIC_ASSET__0c2a388c__"